import { gatewayService } from "@/_services/gateway.service";

/**
 * Retrieves incoterms
*/

export function getIncoterms(_this) {
    gatewayService.catalogs
    .incoterms({ format: "json" })
    .then(data => {
        _this.incoterms = data;
        let txt = "One of the following: ";
        _this.incoterms.forEach((d, i) =>
          i < _this.incoterms.length - 1
            ? (txt += d.name + ", ")
            : (txt += d.name + ".")
        );
        _this.incoterms.unshift({
          explanation: "",
          name: "",
          pk_idincoterms: -1
        });
      })
      .catch(function(error) {
        console.log(error);
      });
  }
